import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./Components/HomePage/HomePage";
import NagendraJewellers from "./Components/HomePage/NagendraJewellers";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NagendraJewellers />} />
        {/* <Route
          path="*"
          element={
            isAuthenticated ? (
              <Routes>
                <Route path="/tax-invoice" element={<Tax_invoice />} />
                <Route path="/sale-return" element={<SaleReturn />} />
              </Routes>
            ) : (
              <Navigate to="/" />
            )
          }
        /> */}
      </Routes>
    </Router>
  );
}

export default App;
